import * as React from "react";
const SvgIcon11 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}><g transform="translate(-335 -370.461)"><circle cx={8} cy={8} r={8} transform="translate(335 370.461)" style={{
      opacity: 0.15,
      fill: "var(--accent-color,#ca40cc)"
    }} /><path d="M343.627 383.333v-3.295h-3.294v-1.412h3.294v-3.294h1.412v3.294h3.294v1.412h-3.294v3.295Z" transform="translate(-1.333 -.873)" style={{
      fill: "var(--accent-color,#ca40cc)"
    }} /></g></svg>;
export default SvgIcon11;